<div mat-dialog-content>
  <app-addedit-hauler
    [haulerData]="data"
    (onFormSubmit)="onFormSubmit($event)"
  ></app-addedit-hauler>
</div>
<div mat-dialog-actions align="end"></div>
